import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { jiraTask_template } from "../components/templates/jiraTask_template";

declare var ko: any;
declare var page: any;

export class jiraTask extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected jiraTask_template: jiraTask_template;

    protected getModuleName(){

        return "jiraTask";
    }

    buildContent() : Array<Element>{
        this.jiraTask_template = new jiraTask_template("jiraTask", this.viewModel, this);
        this.template = this.jiraTask_template;
        return [this.jiraTask_template.build()];
    }

    public fillPage() : void{
        
        this.getListFormData();

        this.getSearchPresetsListData();
    }

    protected updateFilters(responseParsed: any){
    
        //
        //Process App filters to make sure they are in the right format
        let apps = [];

        for ( let item of responseParsed.apps.items){

            let app = {"id" : item.id, "name" : item.name};
            apps.push(app);
        }

        //
        //Process Status filters to make sure they are in the right format and by default we do not want to show the Done or Cancelled statuses
        let statusItems = [];

        for ( let item of responseParsed.status.items){

            let stat = {"id" : item.id, "name" : item.id};
            statusItems.push(stat);
        }

        // //
        // By default, we do not want to show the Done or Cancelled statuses, the user will be able to select them
        let selectedItems = {"selectedItemList" : [], "selectedItemTags" : []};
        let selectedItemList = responseParsed.status.items;
        selectedItemList.splice(selectedItemList.findIndex(x => x.id == 'Done'), 1);
        selectedItemList.splice(selectedItemList.findIndex(x => x.id == 'Cancelled'), 1);

        let selectedItemTags = [];
        responseParsed.status.items.forEach(function(item){
            if (item.id != 'Done' && item.id != 'Cancelled'){
                selectedItemTags.push(item.id);
            }
        });

        selectedItems.selectedItemList = selectedItemList;
        selectedItems.selectedItemTags = selectedItemTags;

        this.jiraTask_template.setStatusFilterItems(statusItems, selectedItems);
        this.jiraTask_template.setAppsFilterItems(apps);
    }

    protected paginationOnPageClick(){

        this.getItemList();
    }

    protected userListReorder(){

        this.getItemList();
    }

    protected filterSimpleOnChange(){
        this.getItemList();
    }

    protected filterDropdownOnChange() {

        this.getItemList();
    }

    protected getListFormData(){

        let usrReq_url: string = '/api/jiraTask/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.jiraTask_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getItemList();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.jiraTask_template.builtTemplate);
            }
        };
    }

    public getItemList(): void{

        this.loadingIn(this.jiraTask_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.jiraTask_template.getViewModelForRequest();
        let baseApiUrl = '/api/jiraTask/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'get');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.jiraTask_template.validationsList.clearMessages();
                obj.updateList(responseParsed);
                
            });

            if(req.request.readyState == 4 && req.request.status != 0){

                // LOADING : ends
                obj.loadingOut(obj.jiraTask_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }


    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        let jiraTasksToSet = [];

        for (let item of responseParsed.data.jiraTasks) {

            jiraTasksToSet.push( {

                keyIssue : item.keyIssue
                ,title: item.title
                ,statusName: item.jiraStatusName
                ,lastStatusUpdateDate: item.lastStatusUpdateDate

            } );

        }

        this.jiraTask_template.setJiraTasks(jiraTasksToSet);
        this.jiraTask_template.updatePagination(responseParsed.data.totalCount);
    }

    protected onUpdateError(requestStatus: any, responseParsed) : void{

        let msg = "error: while retrieving the data";
        this.jiraTask_template.validationsList.setSingleMessage({field: "error", "label": "code " + requestStatus, message: responseParsed.message});

        window.scrollTo(0, 0);
    }

    public filterSimpleCancel(): void {

        console.log('filterSimpleCancel');
    }

    protected filterMultipleSelectorOnChange(){
        
        this.getItemList();
    }

    public listReorder(): void {

        this.getItemList();
    }

    protected filterDateOnChange() {

        this.getItemList();
    }
}



// WEBPACK FOOTER //
// ./js/modules/jiraTask.ts